<script setup lang="ts">
interface Props {
  title?: string;
  width?: string;
  value?: boolean;
  id?: string;
  isRequired?: boolean;
  errorMessage?: string;
  showTitle?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  title: "",
  width: "100%",
  value: true,
  id: "",
  isRequired: false,
  errorMessage: "",
  showTitle: true,
});

const emit = defineEmits<{
  returnValue: [value: boolean];
}>();

const checkboxValue = ref(props.value);

watch(
  () => props.value,
  (to) => {
    checkboxValue.value = to;
  },
);

function returnValue(value: boolean) {
  emit("returnValue", value);
}
</script>

<template>
  <div class="checkbox-field">
    <input
      v-model="checkboxValue"
      class="checkbox-field__input"
      :class="checkboxValue && 'fill'"
      type="checkbox"
      @change="returnValue(($event.target as HTMLInputElement).checked)"
    />
    <p
      v-if="title.length > 0"
      class="checkbox-field__title grey-text"
    >
      {{ title }}
    </p>
  </div>
</template>

<style lang="scss">
.checkbox-field {
  display: flex;
  align-items: center;
  &__title {
    padding-left: 0.4rem;
    margin: 0;
  }
  &__input {
    width: 1.1rem !important;
    height: 1.1rem !important;
    min-width: 1.1rem !important;
    min-height: 1.1rem !important;
    max-width: 1.1rem !important;
    max-height: 1.1rem !important;
    border-radius: 0.25rem !important;
    border: 1.5px solid var(--color-grey-3);
    background-color: var(--color-white-1);
    padding: 0 !important;
    margin: 0;
    cursor: pointer;
    flex: 0 0 auto;
    line-height: 1 !important;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    display: inline-block;
    position: relative;
    transition:
      background-color var(--dur-fast) var(--ease-out),
      border-color var(--dur-fast) var(--ease-out);
  }
  .fill {
    background-color: var(--color-pink-1);
    border-color: var(--color-pink-1);
    // White tick glyph via pure CSS so we don't rely on FontAwesome here.
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 45%;
      width: 0.3rem;
      height: 0.55rem;
      border: solid var(--color-white-1);
      border-width: 0 2px 2px 0;
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }
}
</style>
